export var Type = {
  Default: 'default',
  Localization: 'localization'
};